import bcrypt from "bcryptjs";

/**
 * Reads stored bcrypt hash for private-store passkey checks from `BizSettings.BizPasskeyHash`.
 * @param {object|null|undefined} bizSettings
 * @returns {string}
 */
export function getBizPasskeyHashFromSettings(bizSettings) {
  if (!bizSettings || typeof bizSettings !== "object") return "";
  const fromPascal = bizSettings.BizPasskeyHash;
  if (typeof fromPascal === "string" && fromPascal.trim()) return fromPascal.trim();
  return "";
}

/**
 * @param {string} passkey
 * @param {string} storedHash
 * @returns {boolean}
 */
export function compareStorePasskey(passkey, storedHash) {
  const trimmed = typeof passkey === "string" ? passkey.trim() : "";
  if (!trimmed || !storedHash || typeof storedHash !== "string") return false;
  return bcrypt.compareSync(trimmed, storedHash);
}
